<template>

    <div class="">
        <div class="">
            <div class="component__account__title layout__overflow-hidden text__align-left" v-if="getPhotofixrTotal.photofixr.total > 0">
                <div class="layout__padding-0-20">
                    <router-link to="/photofixr/selections" class="link__colour-black">
                        <div class="layout__width-50 layout__position-left">Photofixr</div>
                        <div class="layout__width-50 layout__position-left text__align-right">{{getPhotofixrTotal.photofixr.total}}</div>
                    </router-link>
                </div>
            </div>
            <div class="component__account__title layout__overflow-hidden text__align-left" v-if="getPhotofixrTotal.instantPrint.total > 0">
                <div class="layout__padding-0-20">
                    <router-link to="/instant-print/artwork-preview" class="link__colour-black">
                        <div class="layout__width-50 layout__position-left">Instant Print</div>
                        <div class="layout__width-50 layout__position-left text__align-right">{{getPhotofixrTotal.instantPrint.total}}</div>
                        <div></div>
                    </router-link>
                </div>
            </div>
        </div>

    </div>

</template>

<script>

    import {mapGetters, mapActions} from 'vuex';

    export default {
        name: "basket",
        mixins: [],
        components: {},
        props: {},
        data() {
            return {}
        },
        computed: {
            ...mapGetters(
                ['getPhotofixrTotal', 'getOrderTotal', 'getInstantPrintTotal'])
        },
        created() {
        },
        methods: {}
    };
</script>
